import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { COMMON, REPORT } from "../config/apiEndPoint";
import { POST, POST_V2 } from "config/api.config";
import { resolveAsyncTeamFilterPageName } from "helpers/metadataFilterHelpers";

const normalizeSelectOptions = (payload) => {
    const list = Array.isArray(payload)
        ? payload
        : Array.isArray(payload?.data)
            ? payload.data
            : Array.isArray(payload?.records)
                ? payload.records
                : Array.isArray(payload?.rows)
                    ? payload.rows
                    : [];

    return list
        .map((item) => {
            const value = String(
                item?.value ?? item?.id ?? item?._id ?? item?.key ?? item?.code ?? ""
            ).trim();
            const label = String(
                item?.label ??
                    item?.display ??
                    item?.data ??
                    item?.name ??
                    item?.title ??
                    value
            ).trim();
            if (!value) return null;
            return { value, label: label || value };
        })
        .filter(Boolean);
};

/** POST V2 `common/team` — Team Performance Report upper filter (`ReportUnrestricted`). */
export const fetchTeamPerformanceReportTeamOptions = async (
    pageName = "ReportUnrestricted"
) => {
    try {
        const resolvedPageName = resolveAsyncTeamFilterPageName(pageName) || pageName;
        if (!resolvedPageName) return [];
        const response = await POST_V2(COMMON.TEAM, { pageName: resolvedPageName });
        return normalizeSelectOptions(response?.data ?? response);
    } catch (error) {
        toast.error(error?.message);
        return [];
    }
};

/** POST `Report/team-performance/filter` */
export const submitTeamPerformanceReportFilterData = async (data = {}) => {
    try {
        const response = await POST(REPORT.TEAM_PERFORMANCE_FILTER, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
